import { useCallback, useMemo, useEffect } from "react";
import { defineMessages } from "react-intl";
import { useSelector, useDispatch } from "react-redux";
import { getViewActions } from "../../redux-folder/view/actions.js";
import "rxjs";
import "rxjs/operators";
import "typesafe-actions";
import "@opentelemetry/api";
import "../../otel/TraceProvider.js";
import "react-error-boundary";
import "@opentelemetry/context-zone";
import "@opentelemetry/exporter-trace-otlp-http";
import "@opentelemetry/instrumentation";
import "@opentelemetry/instrumentation-document-load";
import "@opentelemetry/instrumentation-xml-http-request";
import "@opentelemetry/resources";
import "@opentelemetry/sdk-trace-web";
import "@opentelemetry/semantic-conventions";
import "redux-observable";
import "../../api/types.js";
import "immer";
import { isStringNullOrEmpty } from "../../utils/string.js";
import "moment-timezone";
import "@apollo/client/errors";
import "@apollo/client";
import "graphql";
import "@apollo/client/link/subscriptions";
import "@apollo/client/utilities";
import "cross-fetch";
import "graphql-ws";
import "../../node_modules/moment/dist/moment.js";
import "rxjs/ajax";
import "../../redux-folder/async-action/action.js";
import "../../redux-folder/error-handling/action.js";
import "../../redux-folder/actions.js";
import "fast-deep-equal/es6";
import "redux";
import "../../redux-folder/entity/epics.js";
import "normalizr";
import "../../redux-folder/entity/EntityProvider.js";
import "../../redux-folder/realtime/RealtimeNotification.js";
import "reselect";
import { useViewInit } from "../../redux-folder/view/hooks.js";
import { bulkActionsActions, PollingState } from "./actions.js";
import { manualCreditResultValueSelector, p2pSettingsResultValueSelector, p2pTransferResultValueSelector, removeUserLabelResultValueSelector, addUserLabelResultValueSelector, manualTransactionResultValueSelector, manualTriggerCasinoCoinBonusResultValueSelector, manualTriggerMTTTicketResultValueSelector, manualTriggerImmediateCashBonusResultValueSelector, manualTriggerDepositCashMatchResultValueSelector, notesAttachmentsResultValueSelector, messageResultValueSelector, securityCaseAllResultValueSelector, securityCaseRemoveResultValueSelector, securityCaseUpdateResultValueSelector, securityCaseAddResultValueSelector, sportsbookLockResultValueSelector, casinoLockResultValueSelector, lobbyLockResultValueSelector, depositLockResultValueSelector, withdrawalLockResultValueSelector, accountLockResultValueSelector, actionsDataWithoutSkippedItemsSelector, itemsSelector, bulkOperationsErrorsSelector, bulkFailedOperationActionKeysSelector, bulkOperationNotCreatedActionKeys, isExecutionInProgressSelector, hasExecutionFailedItemsSelector, executionItemsSelector, bulkOperationsFilterSelector } from "./selectors.js";
import { BulkActionKey, BulkItemStatus, bulkItemFailedStatues } from "./types.js";
const localized = defineMessages({
  bulkStepExecutionSummaryOperationNotCreated: {
    id: "bulkStepExecutionSummary_OperationNotCreated",
    defaultMessage: "Operation is failed"
  }
});
function useBulkAction(loadItemsPayload) {
  const dispatch = useDispatch();
  const resetBulkState = () => {
    dispatch(bulkActionsActions.clearBulkActions());
    if (loadItemsPayload) {
      dispatch(bulkActionsActions.loadItems(loadItemsPayload));
    }
  };
  return { resetBulkState };
}
function useAffectedRecords() {
  const allActions = useSelector(actionsDataWithoutSkippedItemsSelector);
  const affectedRecords = useSelector(itemsSelector);
  const result = {};
  for (const actionKey in allActions) {
    result[actionKey] = affectedRecords?.filter((user) => allActions[actionKey]?.map((i) => i.itemId)?.includes(user.serverId))?.map((i) => {
      const value = allActions[actionKey]?.find((a) => a.itemId === i.serverId)?.value;
      return typeof value === "object" ? { ...i, ...value } : i;
    });
  }
  return result;
}
const useBulkModalStatus = () => {
  const actions = useSelector(actionsDataWithoutSkippedItemsSelector);
  const actionItemPayloads = Object.values(actions)?.flatMap((i) => i);
  const processingItemStatuses = [BulkItemStatus.Pending, BulkItemStatus.InProgress];
  const hasProcessingItem = actionItemPayloads?.some((i) => processingItemStatuses.includes(i.status));
  const hasFailedItem = actionItemPayloads?.some((i) => bulkItemFailedStatues.includes(i.status));
  return {
    hasProcessingItem,
    hasFailedItem
  };
};
const useBulkActionResultValue = () => {
  const resultValues = {
    [BulkActionKey.AccountLock]: useSelector(accountLockResultValueSelector),
    [BulkActionKey.WithdrawalLock]: useSelector(withdrawalLockResultValueSelector),
    [BulkActionKey.DepositLock]: useSelector(depositLockResultValueSelector),
    [BulkActionKey.LobbyLock]: useSelector(lobbyLockResultValueSelector),
    [BulkActionKey.CasinoLock]: useSelector(casinoLockResultValueSelector),
    [BulkActionKey.SportsbookLock]: useSelector(sportsbookLockResultValueSelector),
    [BulkActionKey.SecurityCasesAdd]: useSelector(securityCaseAddResultValueSelector),
    [BulkActionKey.SecurityCasesUpdate]: useSelector(securityCaseUpdateResultValueSelector),
    [BulkActionKey.SecurityCasesRemove]: useSelector(securityCaseRemoveResultValueSelector),
    [BulkActionKey.SecurityCasesAll]: useSelector(securityCaseAllResultValueSelector),
    [BulkActionKey.Message]: useSelector(messageResultValueSelector),
    [BulkActionKey.NotesAndAttachments]: useSelector(notesAttachmentsResultValueSelector),
    [BulkActionKey.ManualTriggerDepositCashMatch]: useSelector(manualTriggerDepositCashMatchResultValueSelector),
    [BulkActionKey.ManualTriggerImmediateCashBonus]: useSelector(manualTriggerImmediateCashBonusResultValueSelector),
    [BulkActionKey.ManualTriggerMTTTicket]: useSelector(manualTriggerMTTTicketResultValueSelector),
    [BulkActionKey.ManualTriggerCasinoCoinBonus]: useSelector(manualTriggerCasinoCoinBonusResultValueSelector),
    [BulkActionKey.ManualTransactions]: useSelector(manualTransactionResultValueSelector),
    [BulkActionKey.AddUserLabel]: useSelector(addUserLabelResultValueSelector),
    [BulkActionKey.RemoveUserLabel]: useSelector(removeUserLabelResultValueSelector),
    [BulkActionKey.P2PTransfer]: useSelector(p2pTransferResultValueSelector),
    [BulkActionKey.P2PSettings]: useSelector(p2pSettingsResultValueSelector),
    [BulkActionKey.ManualCredit]: useSelector(manualCreditResultValueSelector)
  };
  return resultValues;
};
function useSelectedItems() {
  const selectedItems = useSelector(itemsSelector);
  return selectedItems;
}
function useBulkStepExecutionSummaryData(operations) {
  const failedOperationKeys = useSelector(bulkOperationNotCreatedActionKeys);
  const isExecutionInProgress = useSelector((state) => isExecutionInProgressSelector(state, { operations }));
  const hasFailedItems = useSelector((state) => hasExecutionFailedItemsSelector(state, { operations }));
  const actionItems = useSelector((state) => executionItemsSelector(state, { operations }));
  const operationIdFilter = useSelector(bulkOperationsFilterSelector);
  return {
    isExecutionInProgress,
    isExecutionFailed: failedOperationKeys?.length > 0 || hasFailedItems,
    actionItems,
    failedOperationKeys,
    operationIdFilter
  };
}
function useExecutionActions(actionItems, actionData) {
  const dispatch = useDispatch();
  const failedOperationKeys = useSelector(bulkFailedOperationActionKeysSelector);
  const performPayload = Object.entries(actionItems).map(([actionKey, payloads]) => {
    const items = failedOperationKeys.includes(actionKey) ? payloads.map((i) => ({ ...i, status: BulkItemStatus.Failed })) : payloads;
    const peformData = actionData?.find((i) => i.actionKey === items?.[0]?.actionKey);
    return {
      strategy: peformData?.strategy,
      postProcessingAction: peformData?.type === "operation" ? bulkActionsActions.saveOperationId : bulkActionsActions.changeBulkActionStatus,
      request: items?.length ? { items, actionKey } : null
    };
  }).filter((s) => s.request !== null);
  function performExecution() {
    dispatch(bulkActionsActions.perform(performPayload));
  }
  function retryExecution() {
    dispatch(bulkActionsActions.retry(performPayload));
  }
  return { performExecution, retryExecution };
}
function useBatchOperationsPolling(isExecutionInProgress) {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(
      bulkActionsActions.fetchOperations({
        viewType: "BulkExecutionSummary",
        pollingState: isExecutionInProgress ? PollingState.Start : PollingState.Finished
      })
    );
  }, [isExecutionInProgress]);
}
const executionLocalized = defineMessages({
  bulkStepExecutionSummaryDisplayName: {
    id: "BulkStepExecutionSummary_displayName",
    defaultMessage: "Execution Summary"
  }
});
function useBulkOperationExecution(viewType = "BulkExecutionSummary", bulkOperationEntityType) {
  const dispatch = useDispatch();
  const fields = ["id", "status", "items.id", "items.status", "items.message", "entity_type"];
  const {
    items: operations,
    viewEntity: { filter: viewFilterString }
  } = useViewInit({
    viewType,
    displayName: executionLocalized.bulkStepExecutionSummaryDisplayName,
    entity: {
      entity: bulkOperationEntityType,
      fields
    },
    validateFilter: (filter) => !isStringNullOrEmpty(filter?.find((f) => f.key === "id")?.value)
  });
  const { isExecutionInProgress, isExecutionFailed, actionItems, failedOperationKeys, operationIdFilter } = useBulkStepExecutionSummaryData(operations);
  useBatchOperationsPolling(isExecutionInProgress);
  useEffect(() => {
    if (operationIdFilter && operationIdFilter !== viewFilterString) {
      const viewActions = getViewActions();
      dispatch(
        viewActions.updateFilter({
          view: viewType,
          entity: bulkOperationEntityType,
          filter: `id=${operationIdFilter}`
        })
      );
    }
  }, [operationIdFilter]);
  return {
    actionItems,
    isExecutionInProgress,
    isExecutionFailed,
    failedOperationKeys
  };
}
function useBulkOperationExecutionError({ isOperationFailed, actionKey, errorMapping }) {
  const operationError = useSelector((state) => bulkOperationsErrorsSelector(state, { actionKey }));
  return isOperationFailed ? operationError && errorMapping?.[operationError] ? errorMapping[operationError] : localized.bulkStepExecutionSummaryOperationNotCreated : null;
}
function useBulkOperationActions() {
  const dispatch = useDispatch();
  const loadItems = useCallback(
    (payload) => {
      dispatch(bulkActionsActions.loadItems(payload));
    },
    [dispatch]
  );
  const clearActions = useCallback(() => {
    dispatch(bulkActionsActions.clearBulkActions());
  }, [dispatch]);
  const validate = useCallback(
    (payload) => {
      dispatch(bulkActionsActions.validate(payload));
    },
    [dispatch]
  );
  const apply = useCallback(
    (payload) => {
      dispatch(bulkActionsActions.apply(payload));
    },
    [dispatch]
  );
  return useMemo(
    () => ({
      loadItems,
      clearActions,
      validate,
      apply
    }),
    [loadItems, clearActions, validate, apply]
  );
}
export {
  useAffectedRecords,
  useBulkAction,
  useBulkActionResultValue,
  useBulkModalStatus,
  useBulkOperationActions,
  useBulkOperationExecution,
  useBulkOperationExecutionError,
  useExecutionActions,
  useSelectedItems
};
//# sourceMappingURL=hooks.js.map
